module.exports = __webpack_public_path__ + "img/icon_turn.06dc1742.svg";